import type { GetterTree } from 'vuex'
import type { RootState } from '../../state'
import type { ScriptTemplatesState } from './state'
import type { ScriptTemplate } from '@/models/scriptTemplates'

export const getters: GetterTree<ScriptTemplatesState, RootState> = {
  getScriptTemplates(state): ScriptTemplate[] {
    return state.scriptTemplates
  },
}
